import React from "react"

const BemooreSection = (props) => {
  return <section className={props.hasCustomStyle && props.customClass} >{props.children}</section>
}

export default BemooreSection
